module.exports = __webpack_public_path__ + "img/bzhjsfw.672c6a1b.png";